import CheckBoxIcon from "@mui/icons-material/CheckBoxRounded";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlankRounded";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBoxRounded";
import { StyledCheckbox } from "./styled";
import { ICheckboxProps } from "./types";

const Checkbox = ({
    color = "primary",
    icon,
    checkedIcon,
    indeterminateIcon,
    ...props
}: ICheckboxProps) => (
    <StyledCheckbox
        {...props}
        customColor={color}
        icon={icon ?? <CheckBoxOutlineBlankIcon />}
        checkedIcon={checkedIcon ?? <CheckBoxIcon />}
        indeterminateIcon={indeterminateIcon ?? <IndeterminateCheckBoxIcon />}
    />
);

export { Checkbox };
